'use client';
import { useCartContext } from "@/providers/CartContext";
import { useProductContext } from "@/providers/ProductContext";
import { useWishlistContext } from "@/providers/WshlistContext";
import {useTranslations} from 'next-intl';
import {useBaseMutation} from '@/libs/api/baseRequests';
import {UPDATE_CLIENT_CART_SELF_QUERY, UPDATE_CLIENT_WISHLIST_SELF_QUERY} from '@/graphql/account';
import {useState} from 'react';
import {useUserContext} from '@/providers/UserContext';

export default function ProductCardViewPort({ product, isMobile }) {
  const t = useTranslations('catalog');
  
  const { user } = useUserContext();
  const { setCurrentProduct } = useProductContext();
  const { addProductToCart } = useCartContext();
  const { updateWishlist, hasWishlist } = useWishlistContext();
  
  const [submitting, setSubmitting] = useState(false);
  const {mutate: mutateCart} = useBaseMutation(UPDATE_CLIENT_CART_SELF_QUERY, {});
  const {mutate: mutateWishlist} = useBaseMutation(UPDATE_CLIENT_WISHLIST_SELF_QUERY, {});
  
  const isInWishlist = hasWishlist(product);
  
  const addToCart = async () => {
    if (!user) {
      // setCurrentProduct(product);
      addProductToCart(product, 1);
      return;
    }
    
    setSubmitting(true);
    const result = await mutateCart({
      variables: {
        action: 'UPDATE_OR_CREATE',
        productId: product.id,
        quantity: 1
      }
    });
    if (result.data) {
      // setCurrentProduct(product);
      addProductToCart(product, 1);
    }
    setSubmitting(false);
  }
  
  const onUpdateWishlist = async () => {
    if (!user) {
      updateWishlist(product);
      return;
    }
    
    setSubmitting(true);
    const result = await mutateWishlist({
      variables: {
        liked: !isInWishlist,
        productId: product.id
      }
    });
    if (result.data) {
      updateWishlist(product);
    }
    setSubmitting(false);
  }
  
  return (
      <div
          className={`${isMobile ? 'product-mobile' : ''} product-hover-action`}
          onClick={(e) => e.preventDefault()}
      >
        <ul>
          <li>
            <button
                type="button"
                title={t('quickView')}
                onClick={() => setCurrentProduct(product)}
                data-bs-toggle="modal"
                data-bs-target="#quick_view_modal"
            >
              <i className="far fa-eye"></i>
            </button>
          </li>
          {' '}
          <li>
            <button
                onClick={addToCart}
                type="button"
                title={t('addToCart')}
                disabled={submitting}
                // data-bs-toggle="modal"
                // data-bs-target="#add_to_cart_modal"
            >
              <i className="fas fa-shopping-cart"></i>
            </button>
          </li>
          {' '}
          <li>
            <button
                onClick={onUpdateWishlist}
                type="button"
                title={t('addToWishlist')}
                disabled={submitting}
            >
              <i className={`fa${isInWishlist ? 's' : 'r'} fa-heart`}></i>{' '}
            </button>
          </li>
        </ul>
      </div>
  );
};
